/**
* Created by lobin on 2020/6/18.
*/
<template>
  <div class="partner">
    <a-card :body-style="{padding: '24px 32px'}" :bordered="false">
      <a-form-model layout="inline" @submit="handleSearch" @submit.native.prevent>
        <a-form-model-item>
          <company-search
            v-model="search.company"
            placeholder="请选择所属公司"
          />
        </a-form-model-item>
        <a-form-model-item>
          <a-input v-model="search.name" placeholder="输入快递员名称" allowClear></a-input>
        </a-form-model-item>
        <a-form-model-item>
          <a-input v-model="search.mobile" placeholder="输入电话" allowClear></a-input>
        </a-form-model-item>
        <a-form-model-item>
          <a-select placeholder="选择状态" v-model="search.status" style="width: 100px;" allowClear>
            <a-select-option
              v-for="item in partnerStatus"
              :key="item.value"
              :value="item.value">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item>
          <a-button
            type="primary"
            html-type="submit"
            icon="search"
          >
            查询
          </a-button>
        </a-form-model-item>
      </a-form-model>
      <a-divider />
      <a-table
          :loading="listLoading"
          :columns="columns"
          :data-source="list"
          :scroll="{ x: 1300, y: 300 }"
          :pagination="pager"
          @change="change">
        <span slot="status" slot-scope="text, record">
          <a-tag color="#f50" v-if="record.status === '0'">待审核</a-tag>
          <a-tag color="#87d068" v-if="record.status === '1'">正常</a-tag>
          <a-tag color="#2db7f5" v-if="record.status === '2'">暂停使用</a-tag>
          <a-tag color="red" v-if="record.status === '3'">审核不通过</a-tag>
          <a-tag color="orange" v-if="record.status === '9'">注销</a-tag>
        </span>
        <span slot="excom" slot-scope="text, record">
          <excom-icon :excom="record.excom.pinyin" :text="record.excom.name" />
        </span>
        <span slot="user" slot-scope="text, record">
          <a-avatar :src="record.user.headimgurl" />
          <span style="margin-left: 10px">{{ record.user.nickname }}</span>
        </span>
        <span slot="unitprice" slot-scope="text, record">
          <span style="margin-left: 10px">{{ record.unitprice }}</span>
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="audit({id: record._id, type: '1'})" v-if="record.status == '0' || record.status == '3'">审核通过</a>
          <a @click="audit({id: record._id, type: '0'})" v-if="record.status == '1'">取消通过</a>
          <a-divider type="vertical" />
          <a @click="rechargeAction(record._id)">充费</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link" @click="e => e.preventDefault()">
              更多<a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a href="javascript:;" @click="showStationQrcode(record)">暂停使用</a>
              </a-menu-item>
              <a-menu-item>
                <a href="javascript:;" @click="showStationQrcode(record)">指定单价</a>
              </a-menu-item>
              <a-menu-item>
                <a href="javascript:;" @click="showStationQrcode(record)">分配可投递站点</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </a-card>
    <a-modal
      title="快递员充值"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="recharge"
      @cancel="handleCancel"
    >
      <a-form :form="rechargeForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
        <a-form-item label="充值方式">
          <a-radio-group name="radioGroup" :default-value="1" v-model="rechargeForm.type">
            <a-radio :value="1">充值</a-radio>
<!--            <a-radio :value="2">减去</a-radio>-->
<!--            <a-radio :value="3">终值</a-radio>-->
          </a-radio-group>
        </a-form-item>
        <a-form-item label="充值额">
          <a-input-number id="inputNumber" v-model="rechargeForm.value"  />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script type="text/babel">
import { partnerList, auditPartner, recharge } from '@/api/user';
import { mapGetters } from 'vuex';

const columns = [
  {
    title: '#',
    dataIndex: 'index',
    customRender: (text, row, index) => index + 1,
    key: 'index',
    width: '50px',
  },
  {
    title: '公司',
    dataIndex: 'company.name',
    key: 'companyName',
    ellipsis: true,
  },
  {
    title: '姓名',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '电话',
    dataIndex: 'mobile',
    width: 120,
    key: 'mobil',
  },
  {
    title: '快递公司',
    dataIndex: 'excom.name',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'excom' },
    key: 'excom',
  },
  {
    title: '网点编号',
    dataIndex: 'companyId',
    width: 100,
    key: 'companyId',
  },
  {
    title: '微信用户',
    dataIndex: 'user',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'user' },
    key: 'user',
  },
  {
    title: '状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
    key: 'status',
  },
  {
    title: '余额',
    dataIndex: 'user.account',
    key: 'account',
  },
  {
    title: '单价',
    dataIndex: 'unitprice',
    key: 'unitprice',
    scopedSlots: { customRender: 'unitprice' },
  },
  {
    title: '创建时间',
    dataIndex: 'ctime',
    ellipsis: true,
    width: 140,
    key: 'ctime',
  },
  {
    title: '备注',
    key: 'desc',
    dataIndex: 'desc',
  },
  {
    title: '操作',
    key: 'action',
    fixed: 'right',
    width: 200,
    scopedSlots: { customRender: 'action' },
  },
];

export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      rechargeForm: {},
      columns,
      rechargeValue: 0,
      listLoading: [],
      searchRange: [],
      list: [],
      id: '',
      pager: {
        page: 1,
      },
      search: {
      },
    };
  },
  created() {
    this.getList();
  },
  computed: {
    ...mapGetters(['partnerStatus']),
  },
  methods: {
    async getList() {
      this.listLoading = true;
      try {
        const { data: { docs, pager } } = await partnerList(this.search);
        this.list = docs;
        this.pager = {
          ...pager,
          showTotal: (total) => `共计 ${total} 条信息`,
        };
      } catch (e) {
        this.listLoading = false;
      }
      this.listLoading = false;
    },
    change(pagination) {
      this.search.page = pagination.current;
      this.getList();
    },
    modify({ _id }) {
      this.$router.push(`/company/modify/${_id}`);
    },
    rechargeAction(id) {
      this.id = id;
      this.visible = true;
    },
    handleCancel() {
      this.visible = false;
    },
    handleSearch() {
      this.getList();
    },
    async recharge() {
      const val = this.rechargeForm.value;
      this.confirmLoading = true;
      const { data } = await recharge(this.id, val);
      if (data) {
        this.confirmLoading = false;
        this.visible = false;
        this.$message.success('充值成功');
        this.getList();
      }
    },
    async audit(post) {
      const { data } = await auditPartner(post);
      if (data) {
        this.$message.success('操作成功');
        this.getList();
      }
    },
  },
};

</script>

<style lang="less" rel="stylesheet/less">
.company {
}
</style>
